import { useCallback, useState, Suspense, lazy } from "react";
import classNames from "classnames";
import DeleteRequestModal from "./delete-request-modal";
import SubmitRequestModal from "./submit-request-modal";
import Icon from "./icon";

const ActionButton = lazy(() => import("./action-button"));

const RequestItem = ({
  request,
  labels,
  setCurrentRequest,
  columnItemTitle,
  hideSendCondition,
  deleteObj,
  submitObj,
  editRequest,
  cancelRequest,
  type,
  showChevron,
}) => {
  const [showActions, setShowActions] = useState();
  const [submitModal, setSubmitModal] = useState();
  const [deleteModal, setDeleteModal] = useState();

  const handleViewDetail = useCallback(
    (e) => {
      e.stopPropagation();
      setCurrentRequest(request);
    },
    [setCurrentRequest, request]
  );

  const handleSendRequest = (e) => {
    e.stopPropagation();
    setSubmitModal(true);
  };

  const handleDeleteRequest = (e) => {
    e.stopPropagation();
    setDeleteModal(true);
  };

  const handleEditRequest = (e) => {
    e.stopPropagation();
    if (editRequest) {
      editRequest(request);
    } else {
      console.warn("No edit request function provided");
    }
  };

  const handleCancelRequest = (e) => {
    e.stopPropagation();
    if (cancelRequest) {
      cancelRequest(request);
    } else {
      console.warn("No cancel request function provided");
    }
  };

  return (
    <>
      <li className="table__item" id={`request-${request?.id}`} onClick={handleViewDetail}>
        {columnItemTitle?.map((option, i) => (
          <div
            key={option.name || i}
            className={classNames(
              "table__box",
              option?.className,
              option.name === "STATUS" && "table__box--fixed"
            )}
          >
            <div className="table__mobile-title">{option.label}</div>
            <div>{option.getContent(request)}</div>
          </div>
        ))}
        {showChevron(request) ? (
          <div className="action">
            <Icon name="chevron" className="action__chevron" />
          </div>
        ) : (
          <Suspense
            fallback={
              <div className="action">
                <div className="loading-spinner" />
              </div>
            }
          >
            <ActionButton
              showActions={showActions}
              setShowActions={setShowActions}
              actions={[
                {
                  action: handleViewDetail,
                  hasCondition: false,
                  icon: "info",
                  label: labels?.WELFARE_BORSE_VIEW_DETAIL || "View detail",
                },
                ...(request?.status === "DRAFT" && !hideSendCondition
                  ? [
                      {
                        action: handleSendRequest,
                        icon: "paper-plane",
                        label: labels?.WELFARE_BORSE_SEND || "Send",
                      },
                    ]
                  : []),
                ...(type === "osteopata-next"
                  ? request?.status === "BOOKED"
                    ? [
                        {
                          action: handleEditRequest,
                          icon: "pencil",
                          label: labels?.WELFARE_EDIT || "Edit",
                        },
                        {
                          action: handleCancelRequest,
                          icon: "calendar-xmark",
                          label: labels?.WELFARE_OSTEOPATA_DISCARD || "Cancel",
                        },
                      ]
                    : []
                  : []),
                ...((
                  type?.startsWith("osteopata")
                    ? type === "osteopata-past" ||
                      (type === "osteopata-next" &&
                        ["CANCELLED_BY_USER", "CANCELLED_BY_OSTEOPATH"].includes(request?.status))
                    : !["ASSIGNED", "NOT_ASSIGNED"].includes(request?.status)
                )
                  ? [
                      {
                        action: handleDeleteRequest,
                        icon: "trash",
                        hasCondition: false,
                        label: labels?.WELFARE_BORSE_DELETE || "Delete",
                      },
                    ]
                  : []),
              ]}
            />
          </Suspense>
        )}
      </li>
      <SubmitRequestModal
        show={submitModal}
        closeModal={() => setSubmitModal(false)}
        key={submitModal}
        saveDraft={() => setSubmitModal(false)}
        submitObject={submitObj}
        request={request}
      />
      <DeleteRequestModal
        show={deleteModal}
        closeModal={() => setDeleteModal(false)}
        request={request}
        labels={labels}
        object={deleteObj}
      />
    </>
  );
};

export default RequestItem;
